import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterDeliveryWindow extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    return orderProducts.sort((a, b) => {
      const itemA = a.deliveryWindow
        ? `${a.availability}${a.deliveryWindow?.name}`
        : a.availability;
      const itemB = b.deliveryWindow
        ? `${b.availability}${b.deliveryWindow?.name}`
        : b.availability;

      if (itemA && itemB) {
        if (itemA > itemB) {
          return 1;
        }
        if (itemA < itemB) {
          return -1;
        }
      }
      return 0;
    });
  }
}

export default OrderProductsSorterDeliveryWindow;
